import React from 'react';
import { Routes, Route, useParams, useLocation } from 'react-router';
import YesplanAppFrame from './YesplanAppFrame';
import ErrorPage from '../components/ErrorPage/ErrorPage';
import IntlProviderDefaultMessages from '../components/IntlProviderDefaultMessages';
import '../css/base.scss';
import { createBrowserHistory } from 'history';
import HistoryListenerRouter from '../components/HistoryListenerRouter';

export default function YesplanAppRoot(props) {
  window.checkAccessToSessionStorage = () => {
    try {
      const sessionStorage = window.sessionStorage || {};
      return true;
    } catch (_) {
      return false;
    }
  };

  const history = createBrowserHistory();
  const YesplanAppFrameWithRouterProps = () => {
    const params = useParams();
    const routerProps = { match: { params }, location: useLocation(), history };
    return <YesplanAppFrame {...props} {...routerProps} />;
  };
  const ErrorPageWithRouterProps = () => {
    const params = useParams();
    const routerProps = { match: { params }, location: useLocation(), history };
    return (
      <IntlProviderDefaultMessages locale="en">
        <ErrorPage {...routerProps} errorCode={404} />
      </IntlProviderDefaultMessages>
    );
  };

  if (window.checkAccessToSessionStorage()) {
    return (
      <HistoryListenerRouter history={history}>
        <Routes>
          <Route path="/:domain/:host/*" element={<YesplanAppFrameWithRouterProps />} />
          <Route path="*" element={<ErrorPageWithRouterProps />} />
        </Routes>
      </HistoryListenerRouter>
    );
  }
  return (
    <IntlProviderDefaultMessages locale="en">
      <ErrorPage clientErrorMessage="Allow the Yesplan App to set cookies on your device. The page failed to load because of your browser’s settings." />
    </IntlProviderDefaultMessages>
  );
}
